module.exports = __webpack_public_path__ + "img/Ossetia.8d82a9bd.svg";